import {
  CardItemContainer,
  CardItemPartner,
  CardItemWrapper,
  Container,
  MtLayoutTitleWrapper,
  SectionTitle,
} from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import type { MtAdvantagesPageProps } from './types';

export * from './types';

export const MtAdvantagesPage: FC<MtAdvantagesPageProps> = (props) => {
  const { items } = props;
  const { translate } = useTranslation({ keyPrefix: 'mt.advantages' });

  return (
    <Container>
      <MtLayoutTitleWrapper>
        <SectionTitle>{translate('title')}</SectionTitle>
      </MtLayoutTitleWrapper>

      <CardItemContainer>
        {items.map((item, index) => (
          <CardItemWrapper key={index}>
            <CardItemPartner
              title={item.name}
              text={item.text}
              ctaLabel={item.cta}
              image={item.logo}
              onClick={item.onClick}
            />
          </CardItemWrapper>
        ))}
      </CardItemContainer>
    </Container>
  );
};
